import { forwardRef } from 'react';
import classes from './CardRow.module.css';
import { HTMLDivProps } from '@blueprintjs/core';
import { classNames } from '../../utils/classNames';

export const CardRow = forwardRef<HTMLDivElement, HTMLDivProps>(function (
  { className, ...props },
  ref
) {
  return (
    <div ref={ref} className={classNames(classes.row, className)} {...props} />
  );
});
